var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKebabHorizontalAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 24C16 26.7614 13.7614 29 11 29C8.23858 29 6 26.7614 6 24C6 21.2386 8.23858 19 11 19C13.7614 19 16 21.2386 16 24ZM30 24C30 26.7614 27.7614 29 25 29C22.2386 29 20 26.7614 20 24C20 21.2386 22.2386 19 25 19C27.7614 19 30 21.2386 30 24ZM39 29C41.7614 29 44 26.7614 44 24C44 21.2386 41.7614 19 39 19C36.2386 19 34 21.2386 34 24C34 26.7614 36.2386 29 39 29Z",
    fill: "#858199"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKebabHorizontalAlt);
export default __webpack_public_path__ + "static/media/iconKebabHorizontalAlt.62d3f5b9.svg";
export { ForwardRef as ReactComponent };